import React from 'react'

export default function NotFound() {
  return (
    <div className='container mt-20 mx-auto text-center text-4xl font-bold'>404 Not Found</div>
  )
}
